import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { gmapApi } from "gmap-vue";

export default {
  methods: {
    isInsideViewport(map, obj) {
      var latMin = map.getBounds().getNorthEast().lat()
      var latMax = map.getBounds().getSouthWest().lat()
      var lngMax = map.getBounds().getNorthEast().lng()
      var lngMin = map.getBounds().getSouthWest().lng()
      var lat = obj.lat()
      var lng = obj.lng()
      if( lat >= latMin && lat <= latMax && lng >= lngMin && lng <= lngMax) {
        return true
      }
      else {
        return false
      }
    },
    toLatLng(obj, lng) {
      if(typeof(obj2) != "undefined") {
        // eslint-disable-next-line
        return new google.maps.LatLng(obj, lng)
      }
      else if(typeof(obj.latitude) != "undefined" && typeof(obj.longitude) != "undefined") {
        // eslint-disable-next-line
        return new google.maps.LatLng(obj.latitude, obj.longitude)
      }
      else if(typeof(obj._lat) != "undefined" && typeof(obj._lng) != "undefined") {
        // eslint-disable-next-line
        return new google.maps.LatLng(obj._lat, obj._lng)
      }
      else if(typeof(obj.lat) != "undefined" && typeof(obj.lng) != "undefined" && !(obj.lat instanceof Function) && !(obj.lng instanceof Function)) {
        // eslint-disable-next-line
        return new google.maps.LatLng(obj.lat, obj.lng)
      }
      else if(typeof(obj.lat) != "undefined" && typeof(obj.lng) != "undefined" && (obj.lat instanceof Function)&& (obj.lng instanceof Function)) {
        // eslint-disable-next-line
        return new google.maps.LatLng(obj.lat(), obj.lng())
      }
      else if((obj instanceof Array) && (obj.length == 2)) {
        // eslint-disable-next-line
        return new google.maps.LatLng(obj[0], obj[1])
      }
      else {
        return null
      }
    },
    toGeoPoint(obj, lng) {
      if(typeof(obj2) != "undefined") {
        return new firebase.firestore.GeoPoint(obj, lng)
      }
      else if(typeof(obj.latitude) != "undefined" && typeof(obj.longitude) != "undefined") {
        return new firebase.firestore.GeoPoint(obj.latitude, obj.longitude)
      }
      else if(typeof(obj._lat) != "undefined" && typeof(obj._lng) != "undefined") {
        return new firebase.firestore.GeoPoint(obj._lat, obj._lng)
      }
      else if(typeof(obj.lat) != "undefined" && typeof(obj.lng) != "undefined" && !(obj.lat instanceof Function)&& !(obj.lng instanceof Function)) {
        return new firebase.firestore.GeoPoint(obj.lat, obj.lng)
      }
      else if(typeof(obj.lat) != "undefined" && typeof(obj.lng) != "undefined" && (obj.lat instanceof Function)&& (obj.lng instanceof Function)) {
        return new firebase.firestore.GeoPoint(obj.lat(), obj.lng())
      }
      else if(obj instanceof Array && obj.length == 2) {
        return new firebase.firestore.GeoPoint(obj[0], obj[1])
      }
      else {
        return null
      }


    },
    createPopupClass() {
      function Popup(position, id) {
        this.position = position
        this.element = window.document.getElementById(id)
        // eslint-disable-next-line
        google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.element)
      }
      // eslint-disable-next-line
      Popup.prototype = Object.create(google.maps.OverlayView.prototype)
      Popup.prototype.onAdd = function() {
        this.getPanes().floatPane.appendChild(this.element)
      }
      Popup.prototype.onRemove = function() {
        if (this.element.parentElement) {
          this.element.parentElement.removeChild(this.element)
        }
      }
      Popup.prototype.draw = function() {
        var divPosition = this.getProjection().fromLatLngToDivPixel(this.position)
        var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none'
        if (display === "block") {
            this.element.style.left = divPosition.x + "px"
            this.element.style.top = divPosition.y + "px"
        }
        if (this.element.style.display !== display) {
            this.element.style.display = display;
        }
      }
      return Popup
    },
  },
  computed: {
    google: gmapApi
  }
}
